import { defineComponent as _defineComponent } from 'vue'
import { useMainElement } from '@/pinia/modules/useMainElement';
import { findNowMenu, useUser } from '@/pinia/modules/userData';
import { useRouter } from '@/router';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppMain',
  setup(__props) {

const mainEl = ref<HTMLElement>();
  const memoArr = ref<string[]>([]);
const { setElement }=useMainElement()
const cache = useUser()
watch(storeToRefs(cache).cacheList, (val) => {
  memoArr.value = val.map(item => item?.componentName).filter(Boolean) as string[];  
},{
  immediate:true
});
const router = useRouter()
const key = computed(()=>{
  // console.log(router);
  
  return router.currentRoute.name
})

return { __sfc: true,mainEl, memoArr, setElement, cache, router, key }
}

})